import * as m from "mithril";
import { MessageProvider } from "../../context/AppMessages";
import TripSearchResultSummaryView from "../../components/TripSearchResultSummaryView";
import CustomSvgIcon from "../../components/CustomSvgIcon";
import { OperatorRatingSummaryDTO, TripDTO } from "../../apiclient/ApiDtos";
import { getIntlStringValue } from "../../helpers/StringHelpers";

interface Attrs {
    numberOfSeats: number,
    tripResult: TripDTO,
    messageProvider: MessageProvider,
    onViewSeatButtonClick: (tripResult: any) => void,
    onViewOperatorPhotosButtonClick: (tripResult: any) => void,
    onRatingSummaryClick: (ratingSummary: OperatorRatingSummaryDTO) => void
}

function TripResultCard(): m.Component<Attrs> {
    return {
        view(vnode) {
            let result = vnode.attrs.tripResult;
            //let logoUrl = result.operator.logoUrl;
            //https://res.cloudinary.com/innoveller/image/upload/v1726518352/operator-thumbnails/xx.png         

            return m("div", { class: "card", id: result.id }, [
                m("div.card-body px-3 py-2", [
                    m(TripSearchResultSummaryView, {
                        numberOfSeats: vnode.attrs.numberOfSeats,
                        tripResult: result,
                        messageProvider: vnode.attrs.messageProvider
                    })
                ]),


                (result.highlights && result.highlights.length > 0) &&
                m("div.card-body px-3 py-2", [
                    result.highlights.map(hl => {
                        return m("span.operator-hightlight-tag-service mr-1  mb-1 font-weight-bold text-primary",
                            getIntlStringValue(hl, vnode.attrs.messageProvider.getCurrentLang())
                        )
                    })
                ]
                ),


                m("div", { class: "card-footer bg-white px-3 py-2" },
                    m("div", { class: "d-flex justify-content-between align-items-center" },
                        [
                            m("div", {}, [
                                m("span", {
                                    style: {
                                        "display": "inline-block",
                                        "min-width": "82px",
                                        "max-width": "82px"
                                    }
                                },
                                    m("img.operator-logo-sm", {
                                        style: {
                                            height: '32px',
                                            "max-width": '72px',
                                            "object-fit": "contain"
                                        },
                                        src: result.operator.logoUrl
                                    })
                                ),
                                /*
                                (result.operator.ratingSummary.totalReviewCount > 0)?     
                                [
                                    m(Stars, {value: result.operator.ratingSummary.averageRating}),
                                    m("small.text-primary ml-1 mr-2", {
                                        style:"text-decoration:underline",
                                        onclick: function (event) {
                                            event.preventDefault();
                                            vnode.attrs.onRatingSummaryClick(result.operator.ratingSummary);
                                        }
                                    }, result.operator.ratingSummary.totalReviewCount + " reviews")

                                ] : "",   */

                                m("small.text-primary", {
                                    style: "text-decoration:underline",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        vnode.attrs.onViewOperatorPhotosButtonClick(result);
                                    }
                                }, vnode.attrs.messageProvider.get("operator_photos")),
                            ]),

                            m("div", {},
                                m("a", {
                                    role: "button",
                                    class: "btn btn-primary text-white px-4",
                                    style: "",
                                    href: "#",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        vnode.attrs.onViewSeatButtonClick(result);
                                    }

                                }, [
                                    m("span", { class: "" }, vnode.attrs.messageProvider.get("select")),
                                    // hidden on xs devices
                                    m("span", { class: "ms-1 ml-1 d-none d-sm-inline" },
                                        m(CustomSvgIcon, {
                                            iconType: 'double_chevron_right',
                                            themeCssClass: "svg-x-small svg-white"
                                        })
                                    )
                                ])
                            ),
                        ])
                )
            ]);
        }
    }
}

export default TripResultCard;